<div>
    <sync-dialog 
    [config]="
    {
      title: 'Password hint', 
      isClosable: false, 
      actionButton: 'Save', 
      cancelButton: 'Cancel',
      onActionClick: savePasswordHint,
      onCancelClick: closePasswordHintDialog,
    }"
    [open]="showPasswordHintDialog" 
    [isFullScreen]="false"
    [onClose]="closePasswordHintDialog">
    <div class="pw-hint-container">
        <app-error *ngIf="errcode" [errcode]="errcode" [showErrCode]="showErrCode"></app-error> 
        <span class="body-2">
            Set a word or phrase that can help you remember your password. Your hint will be emailed to you in the event that you’ve forgotten your password.
        </span>
        <div class="pw-hint-block">
            <sync-switch 
                [size]="'large'"
                [label]="'Enable password hint'" 
                [labelPosition]="'before'"
                [checked]="user.has_password_hint !== 0"
                [onChange]="togglePWhint"
            ></sync-switch>
            <sync-text-field 
                class="pw-hint-field"
                *ngIf="passwordHintEnabled" 
                [label]="'Password hint'" 
                [inputChange]="getPasswordHint"
                [errorMessage]="invalidPassHintErr"
            ></sync-text-field>
        </div>
     </div>
    </sync-dialog>
  </div>